// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".lad-reviews--comments{margin-top:10px}.lad-reviews--comments .el-card{border:1px solid #ebeef5;border-radius:5px}.lad-reviews--comments .el-card+.el-card{margin-top:6px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
